import { useContext } from 'react'
import BootstrapDataContext from '../../context/BootstrapDataContext'
import useSeti from './useSeti'

export default function usePrePopFormHeadline(experimentCode: string) {
  const { prePopData } = useContext(BootstrapDataContext)
  const endLocation = prePopData?.hotels?.endLocation
  const hasCity = !!endLocation?.cityName && endLocation?.type === 'CITY'
  const isVariant = useSeti(experimentCode, hasCity) === 'VARIANT'
  return hasCity && isVariant ? `Search ${endLocation?.cityName} Hotels` : null
}
